import { render, staticRenderFns } from "./vidCont.vue?vue&type=template&id=123165d2&scoped=true"
import script from "./vidCont.vue?vue&type=script&lang=js"
export * from "./vidCont.vue?vue&type=script&lang=js"
import style0 from "./vidCont.vue?vue&type=style&index=0&id=123165d2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "123165d2",
  null
  
)

export default component.exports